import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PersianTitlesService } from '../../core/services/persian-titles.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: false,
})
export class NavbarComponent implements OnInit {
  items: any;

  constructor(
    private persianTitlesService: PersianTitlesService,
    private router: Router,
  ) {
    this.initItems();
  }

  itemClick(e: any) {
    if (e && e.urlParts) {
      this.router.navigate(e.urlParts);
    }
  }

  ngOnInit() {}

  private initItems() {
    this.items = [
      {
        id: '0',
        name: this.persianTitlesService.Items.HomePage,
        urlParts: ['/'],
      },
      {
        id: '5',
        name: this.persianTitlesService.Items.Workshops,
        items: [
          {
            id: 'workshops',
            name: this.persianTitlesService.Items.CurrentWorkshops,
            urlParts: ['workshop', 'workshops'],
          },
          {
            id: 'held-workshops',
            name: this.persianTitlesService.Items.HeldWorkshops,
            urlParts: ['held-workshop', 'held-workshops'],
          },
        ],
      },
      {
        id: '4',
        name: this.persianTitlesService.Items.WorkshopsVideo,
        urlParts: ['e-workshop', 'e-workshops'],
      },
      {
        id: '2',
        name: this.persianTitlesService.Items.MyUserInformation,
        urlParts: ['profile', 'edit'],
      },
      {
        id: '3',
        name: this.persianTitlesService.Items.MyTrainingHistory,
        urlParts: ['profile', 'my-training-history'],
      },
      {
        id: 'feedback',
        name: this.persianTitlesService.Items.SuggestionsAndCriticisms,
        urlParts: ['feedback'],
      },
    ];
  }
}
